const NOTIFY_FORM_URL = "https://api.lumi.new/v1/functions/p440726801590865920/notifyForm"

export type NotifyFormName =
  | "Mapa de Cura dos 4 Elementos"
  | "Ciclo 1"
  | "Ciclo 2"
  | "Ciclo 3"
  | "Ciclo 4"
  | "Ciclo 5"
  | "Ciclo 6"
  | "Triagem"

export function notifyFormSubmission(params: {
  name: string
  formName: NotifyFormName
  submittedAt?: string
}): void {
  const payload = {
    name: params.name,
    formName: params.formName,
    submittedAt: params.submittedAt || new Date().toISOString(),
  }

  void fetch(NOTIFY_FORM_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).catch((err) => {
    console.error("Erro ao enviar notificação de formulário:", err)
  })
}
